import FormattedMessage from 'I18n/components/FormattedMessage';
import { Spacer } from 'foundations-components/components/Spacer';
import { View } from 'foundations-components/components/View';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { PPUIPageHeader, PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { useHistory } from 'react-router-dom';
import AvailableAddOnsList from '../components/available-add-ons-list/AvailableAddOnsList';
import FallbackErrorBanner from '../components/common/loading/FallbackErrorBanner';
import HeaderLayout from '../components/layout/HeaderLayout';
import { OWNERSHIP_CHECK_FAILED } from '../constants/ErrorCauses';
import { SCREENS } from '../constants/tracking/Screens';
import { useGlobalLoading } from '../hooks/loadingHooks';
import { useAddOnsPage } from '../hooks/useAddOnPage';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useAppSelector } from '../reducers';
import { isUngatedForInbound25Selector } from '../selectors/GatingSelectors';
import { hasOnlyOwnershipCheckFailedSelector, hasPricingAndPurchasingFailedSelector } from '../selectors/LoadingStateSelectors';
import { productForSkuIdSelector } from '../selectors/ProductsSelectors';
import { queryParamProductConfigurationsSelector } from '../utils/planBuilderUtils/PlanBuilderQueryParamUtils';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { useQueryParamTerm, useQueryParamsEffect } from '../utils/urls/appQueryParamUtils';
import ErrorPage from './ErrorPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddOnsPage = () => {
  useDocumentTitle('add-ons');
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const history = useHistory();
  const queryParams = getQueryParams();
  const {
    showAddonsPage
  } = useAddOnsPage();
  const isAppReady = useGlobalLoading();
  const hasPricingAndPurchasingFailed = useAppSelector(hasPricingAndPurchasingFailedSelector);
  useEffect(() => {
    trackPageView({
      screen: SCREENS.ADD_ONS
    });
  }, []);
  useEffect(() => {
    if (isAppReady && !showAddonsPage) {
      history.push('/bundle');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAppReady, showAddonsPage]);
  const hasOnlyOwnershipCheckFailed = useAppSelector(hasOnlyOwnershipCheckFailedSelector);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  const highlightedProduct = useAppSelector(state => {
    const queryParamProductConfigurations = isAppReady ? queryParamProductConfigurationsSelector(state, {
      queryParams
    }) : [];
    if (queryParamProductConfigurations.length === 1) {
      var _productForSkuIdSelec;
      return (_productForSkuIdSelec = productForSkuIdSelector(state, {
        skuId: queryParamProductConfigurations[0].skuId
      })) === null || _productForSkuIdSelec === void 0 ? void 0 : _productForSkuIdSelec.currentVersion;
    }
  });
  if (hasPricingAndPurchasingFailed) {
    if (hasOnlyOwnershipCheckFailed) {
      return /*#__PURE__*/_jsx(ErrorPage, {
        errorCause: OWNERSHIP_CHECK_FAILED
      });
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [isAppReady && /*#__PURE__*/_jsx(NavMarker, {
      name: "ADD_ONS_PAGE"
    }), /*#__PURE__*/_jsx(HeaderLayout, {
      selectedNavItem: 'add-ons',
      children: /*#__PURE__*/_jsxs(View, {
        as: "main",
        inlineSize: "100%",
        children: [/*#__PURE__*/_jsx(Spacer, {
          space: "400"
        }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PPUIPageHeader, {
          children: [/*#__PURE__*/_jsx(PageTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pages.addOns.title"
            })
          }), /*#__PURE__*/_jsx(PageSubTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pages.addOns.subtitle"
            })
          })]
        }), /*#__PURE__*/_jsx(View, {
          maxInlineSize: isUngatedForInbound25 ? '610px' : '684px',
          margin: "auto",
          children: /*#__PURE__*/_jsx(AvailableAddOnsList, {
            screen: SCREENS.ADD_ONS,
            highlightedProduct: highlightedProduct
          })
        })]
      })
    })]
  });
};
export default AddOnsPage;